export default function IconSearch() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.1564 18.3125C16.6609 18.3125 20.3189 14.6608 20.3267 10.1562C20.3345 5.65167 16.6891 2 12.1846 2C7.68 2 4.02201 5.65167 4.01423 10.1562C4.00644 14.6608 7.65181 18.3125 12.1564 18.3125Z" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M7.25195 16.8828L1.99915 22.1447" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
